class languageController {
   constructor($translate) {
      "ngInject";
      this.$translate = $translate;
      this.cur_lang = window.localStorage.yuanben_lang;
   }
   switching(lang) {

      if (lang === "japanese") {
         window.location.href = "http://www.genpon.jp"
         return
      }

      this.$translate.use(lang);
      window.localStorage.yuanben_lang = lang;
      location.reload();
   }
}

export default languageController;



// WEBPACK FOOTER //
// ./src/app/common/language/language.controller.js